import React, { useState, useEffect, useContext, useRef } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import Toolbar from "@mui/material/Toolbar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./sidebar.css";
import { MyContext } from "../App";
import AddIcon from "@mui/icons-material/Add";
import logoimg from "../images/dove_blaster 2.png";
import groupimg from "../images/Group.png";
import Locationicon from "../assets/land 1.png";
import Locationiconcolor from "../assets/Layer 1.png";
import Coupon from "../assets/coupon 1.png";
import Layer from "../assets/Layer 2.png";
import Chats from "../assets/chat (1).png";
import Rating from "../assets/rating 1.png";
import Reservation from "../assets/reservation 1.png";
import Areaset from "../assets/Asmanage_areaset 1 1.png";
import Dashboardicon from "../assets/dashboard.svg";
import Huntersicon from "../assets/land.svg";
import Profileimg from "../assets/user.png";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Successicon from "../assets/Check.png";
import Bellicon from "../assets/bell.png";
import Logouticon from "../assets/logout.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toastify, userlogout, clearuser } from "../redux/controller";
import { fetchData } from "../redux/apiSlice";
import { FaMoneyBillWave } from 'react-icons/fa';
import Button from '@mui/material/Button';
import { useWindowWidth } from "./WindowWidth";
import DehazeIcon from '@mui/icons-material/Dehaze';
import { setSelectedSeasonglobal } from "../redux/seasonSlice";
import HelpIcon from '@mui/icons-material/Help';


const drawerWidth = 240;

function opennotification(label) {
  window.location.replace(window.location.origin + label);
}

function Sidebar(props) {
  const initialized = useRef(false);
  const { isTabletDevice } = useWindowWidth();

  const dispatch = useDispatch();
  const [userdata, setuserdata] = useState({});
  const usertoken = useSelector((state) => state.userdata.usertoken);
  const userinfo = useSelector((state) => state.userdata.userdata);
  const [successPopup, setSuccessPopup] = useState(false);
  const [popstatus, setPopStatus] = useState(false);
  const [logoutpopstatus, setLogoutPopStatus] = useState(false);
  const [hunterCount, setHuntersCount] = useState(0);
  const Navigate = useNavigate();
  const Navigatelogout = useNavigate();
  const search = useLocation().search;
  const [open, setOpen] = React.useState(false);


  const isMobile = useContext(MyContext);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  async function opennotificationreservation(label) {
    if (label.type == "reservation") {
      var userdetail = await dispatch(
        fetchData({
          apiurl: "/reservation/single",
          reservationid: label.selectedid,
          headers: { "x-access-token": usertoken },
        })
      );

      if (
        userdetail &&
        userdetail.payload &&
        userdetail.payload.status == 200
      ) {
        console.log(userdetail);
        Navigate("/huntersdetails", {
          state: {
            id: userdetail.payload.data.userid._id,
            hunter_name:
              userdetail.payload.data.userid.firstname +
              " " +
              userdetail.payload.data.userid.lastname,
            email: userdetail.payload.data.userid.email,
            phone_number: userdetail.payload.data.userid.phonenumber,
            createdAt: userdetail.payload.data.userid.createdAt,
          },
        });
      }
    }
  }


  const handlesuccessPopup = () => {
    setSuccessPopup(!successPopup);
  };

  function handleLogout() {
    dispatch(userlogout());
    clearuser();
    Navigatelogout("/");
  }


  function goToProfile() {
    Navigate("/profile")
  }


  function handleLogoutsubmit() {
    setLogoutPopStatus(!logoutpopstatus);
  }

  function handlepopupclose() {
    setLogoutPopStatus(!logoutpopstatus);
  }

  function handleChagepassword() {
    setPopStatus(!popstatus);
  }

  async function handleChagepasswordsubmit() {
    console.log(stepinputField);
    if (stepinputField.newpassword !== stepinputField.confirmpassword) {
      toastify({ message: "Password and Confirm Password do not match!" });
      return;
    }
    if (stepinputField.newpassword.length < 8) {
      toastify({ message: "Password must be at least 8 characters" });
      return;
    } else if (stepinputField.newpassword.search(/[a-z]/) < 0) {
      toastify({
        message: "Password must contain at least one lowercase letter",
      });
      return;
    } else if (stepinputField.newpassword.search(/[A-Z]/) < 0) {
      toastify({
        message: "Password must contain at least one uppercase letter",
      });
      return;
    } else if (stepinputField.newpassword.search(/[0-9]/) < 0) {
      toastify({ message: "Password must contain at least one number" });
      return;
    }
    var body = {
      apiurl: "/auth/change/password",
      password: stepinputField.currentpassword,
      newpassword: stepinputField.newpassword,
      headers: { "x-access-token": usertoken },
    };
    var response = await dispatch(fetchData(body));
    if (response && response.payload && response.payload.status === 200) {
      toastify({ message: response.payload.message });
      setPopStatus(!popstatus);
      setSuccessPopup(true);
    } else {
      if (
        response.payload.response &&
        response.payload.response.data &&
        response.payload.response.data.message
      ) {
        // toastify({ message: response.payload.response.data.message });
        if (
          response.payload.response.data.message === "Invalid token provided!" || response.payload.response.data.message === "No token provided!"
        ) {
          clearuser();
          userlogout();
          Navigate("/");
          window.location.reload();
        }
      }
    }
  }

  async function closeallnotification() {
    if (readnotifications) {
      closenotification("property");
      closenotification("reservation");
      closenotification("payment");
    }
  }

  async function closenotification(type) {
    var body = {
      apiurl: "/auth/user/closenotification",
      type: type,
      headers: { "x-access-token": usertoken },
    };
    await dispatch(fetchData(body));
    getprofile();
  }

  async function getprofile() {
    setpropertynotification(0);
    setreservationnotification(0);
    var body = {
      apiurl: "/auth/profile",
      headers: { "x-access-token": usertoken },
    };
    var response = await dispatch(fetchData(body));
    if (
      response.payload &&
      response.payload.data &&
      response.payload.data.user &&
      response.payload.data.user.notifications
    ) {
      var notifications = response.payload.data.user.notifications;
      // console.log(notifications);
      if (notifications && notifications.length) {
        var reservnotify = notifications.filter(
          (e) => e.type === "reservation"
        );
        if (reservnotify.length) {
          setreservationnotification(reservnotify.length);
        }
        var propnotify = notifications.filter((e) => e.type === "property");
        if (propnotify.length) {
          setpropertynotification(propnotify.length);
        }
        var allnotifications = notifications.filter(
          (e) => e.type === "property" || e.type === "reservation" || e.type == "payment"
        );
        // console.log(allnotifications);
        if (allnotifications) {
          setnotifications(allnotifications.reverse());
          setreadnotifications(
            allnotifications.filter((e) => e.read === false)
          );
        }
      }
    }
  }

  function handleChagepasswordclose() {
    setPopStatus(!popstatus);
  }

  const [currentpage, setcurrentpage] = useState("");
  const [reservationName, setReservationName] = useState("");

  const location = useLocation();
  
  // Menu path mapping for consistent navigation
  const menuPathMap = {
    "Manage Properties": "/managearea",
    "Reservations": "/reservations",
    "Manage Coupons": "/managecoupons",
    "Hunters": "/hunters",
    "Hunters Review": "/huntersreview",
    "Real Time Tracking": "/realtracking",
    "Earnings": "/earnings",
    "Help": "/help"
  };

  // Submenu path mapping
  const subMenuPathMap = {
    "Add New Property": "/addproperty",
    "Manage Areas/Slots": "/managearea"
  };

  useEffect(() => {
    if (userinfo) {
      setuserdata(userinfo);
    }

    const url = location.search;
    const queryString = url.split("?")[1];
    const params = new URLSearchParams(queryString);
    const reservationName = params.get("reservationName");
    setReservationName(reservationName);

    setcurrentpage(location.pathname);
    if (usertoken == "" || usertoken == undefined || usertoken == null) {
      Navigate("/");
    }

    // Set active menu based on current path
    const menuItem = Object.entries(menuPathMap).find(
      ([, path]) => path === location.pathname
    );
    
    if (menuItem) {
      setActiveMenu(menuItem[0]);
    }

    // Set active submenu based on current path
    const subMenuItem = Object.entries(subMenuPathMap).find(
      ([, path]) => path === location.pathname
    );
    
    if (subMenuItem) {
      setActivesubMenu(subMenuItem[0]);
      // Also set the parent menu as active
      if (subMenuItem[0] === "Add New Property" || subMenuItem[0] === "Manage Areas/Slots") {
        setActiveMenu("Manage Properties");
      }
    }

    if (!initialized.current) {
      initialized.current = true;
      getprofile();
    }
  }, [location.pathname, userinfo, usertoken]);

  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activesubMenu, setActivesubMenu] = useState(null);
  const manage_area = useNavigate();
  const manage_navigate = useNavigate();
  const managecoupon_navigate = useNavigate();
  const hunter_navigate = useNavigate();
  const real_navigate = useNavigate();
  const earnings_navigate = useNavigate();
  const chats_navigate = useNavigate();
  const reservations_navigate = useNavigate();
  const changepassword_navigate = useNavigate();
  const drop_navigate = useNavigate();
  const newcoupon_navigate = useNavigate();
  const hunterback_navigate = useNavigate();
  const createcoupon_navigate = useNavigate();
  const property_navigate = useNavigate();
  const realtrack_navigate = useNavigate();

  const [propertynotification, setpropertynotification] = useState(0);
  const [reservationnotification, setreservationnotification] = useState(0);
  const [notifications, setnotifications] = useState([]);
  const [readnotifications, setreadnotifications] = useState([]);
  const [currentpasswordicon, setcurrentpasswordicon] = useState(false);
  const [passwordicon, setpasswordicon] = useState(false);
  const [cpasswordicon, setcpasswordicon] = useState(false);



  const [selectedSeason, setSelectedSeason] = useState("");
  const [seasons, setSeasonData] = useState([]);
  const [isCurrentSeason, setCurrentSeasonSelected] = useState(false);


  const handleSeasonChange = (e) => {
    const id = e.target.value;
    const selected = seasons.find((s) => s._id === id);
    setSelectedSeason(id)
    if (selected) {
      dispatch(setSelectedSeasonglobal(selected));

      const now = new Date();
      const start = new Date(selected.seasonStartDate);
      const end = new Date(selected.seasonEndDate);

      const isCurrent = now >= start && now <= end;
      setCurrentSeasonSelected(isCurrent);
    }
  };

  const getSeasonDetails = async () => {
    try {
      const seasonList = await dispatch(
        fetchData({
          apiurl: "/season/getseasons",
          headers: { "x-access-token": usertoken }
        })
      );

      const seasons = seasonList?.payload?.seasons || [];

      if (seasons.length > 0) {
        setSeasonData(seasons);

        const now = new Date();

        // Find current season
        const currentSeason = seasons.find(season => {
          const start = new Date(season.seasonStartDate);
          const end = new Date(season.seasonEndDate);
          return now >= start && now <= end;
        });

        // Set current season if exists, otherwise first
        if (currentSeason) {
          setSelectedSeason(currentSeason._id);
          dispatch(setSelectedSeasonglobal(currentSeason));
          setCurrentSeasonSelected(true)
        } else {
          setSelectedSeason(seasons[0]._id);
          dispatch(setSelectedSeasonglobal(seasons[0]));
        }
      }
    } catch (error) {
      console.error("Error fetching season data:", error);
    }
  };



  useEffect(() => {
    getSeasonDetails()
  }, [])



  const inputsHandler = (e) => {
    console.log(e.target.name);
    setstepInputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [stepinputField, setstepInputField] = useState({
    currentpassword: "",
    newpassword: "",
    confirmpassword: "",
  });

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleClick = (text) => {
    console.log(text, "text");
    
    // Only navigate if we're not already on this page
    if (menuPathMap[text] && menuPathMap[text] !== location.pathname) {
      setActiveMenu(text === activeMenu ? null : text);
      console.log(`activeMenu ${text} clicked`);
      
      if (text == "Reservations") {
        closenotification("reservation");
      }
      
      // Navigate to the appropriate route using the mapping
      Navigate(menuPathMap[text]);
    } else {
      // If already on the page, just update the active menu state
      setActiveMenu(text);
    }
     setIsClosing(false);
  };

  const handleSubmenuClick = (text) => {
    setActivesubMenu(text === activesubMenu ? null : text);
    console.log(`Submenu ${text} clicked`);
    
    // Navigate to the appropriate route using the mapping
    if (subMenuPathMap[text]) {
      Navigate(subMenuPathMap[text]);
    }
  };

  function handleDocumentation() {
    manage_navigate("/help");
  }

  function handleManageproperties() {
    manage_navigate("/addproperty");
  }

  function handleManage() {
    managecoupon_navigate("/managecoupons");
  }

  function handleHunter() {
    hunter_navigate("/huntersreview");
  }
  function handleRealtracking() {
    real_navigate("/realtracking");
  }
  function handleEarnings() {
    earnings_navigate("/earnings");
  }
  function handleChats() {
    chats_navigate("/chats");
  }
  function handleReservations() {
    reservations_navigate("/reservations");
  }
  function handleCreatecouponback() {
    createcoupon_navigate("/managecoupons");
  }
  function handlePropertyback() {
    // property_navigate("/reservations");
    Navigate(-1);
  }

  function handleHunterBack() {
    newcoupon_navigate("/hunters");
  }



  function handleRealtrackback() {
    realtrack_navigate("/realtracking");
  }
  function handleDrop() {
    // drop_navigate("/profile");
  }

  const currentPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  const currenthandleType = (e) => {
    currentPasswordRef.current.type =
      currentPasswordRef.current.type === "text" ? "password" : "text";
    setcurrentpasswordicon(!currentpasswordicon);
  };

  const handleType = (e) => {
    newPasswordRef.current.type =
      newPasswordRef.current.type === "text" ? "password" : "text";
    setpasswordicon(!currentpasswordicon);
  };

  const chandleType = (e) => {
    confirmPasswordRef.current.type =
      confirmPasswordRef.current.type === "text" ? "password" : "text";
    setcpasswordicon(!currentpasswordicon);
  };

  function handleReservationBack() {
    hunterback_navigate("/reservations");
  }

  async function updateNotificationCount(type) {
    var data = await dispatch(
      fetchData({
        apiurl: "/auth/user/updatenotificationcount",
        headers: { "x-access-token": usertoken },
        type: type,
        userid: userdata._id,
      })
    );
    if (data && data.payload && data.payload.status === 200) {
      if (type == "all") {
        // setNotificationsCount(0)
      } else if (type === "hunter") {
        setHuntersCount(0);
      } else if (type === "landowner") {
        // setLandownerCount(0)
      } else if (type === "property") {
        // setPropertyCount(0)
      } else if (type === "reservation") {
        // setReservationCount(0)
      }
    }
  }

  function handleHunters() {
    updateNotificationCount("hunter");
    Navigate("/hunters");
  }

  const drawer = (
    <div>
      <div className="logo-buttom">
        <img className="logoimg" src={groupimg} alt="logoimg" />
      </div>
      <List>
        <React.Fragment>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => handleClick("Manage Properties")}
              id="firstmenu"
              className={
                activeMenu === "Manage Properties"
                  ? "activeMenu"
                  : "inheritmenu"
              }
            >
              <ListItemIcon>
                <img
                  className={
                    activeMenu === "Manage Properties" ? "loc-img" : "cou-img"
                  }
                  src={
                    activeMenu === "Manage Properties"
                      ? Locationicon
                      : Locationiconcolor
                  }
                  alt="Locationicon"
                />
              </ListItemIcon>
              <ListItemText
                primary="Manage Properties"
                className={
                  activeMenu === "Manage Properties"
                    ? "activeMenu"
                    : "inheritmenu"
                }
              />
              {activeMenu === "Manage Properties" ? (
                <ExpandLess className="arrow" />
              ) : (
                <ExpandMore className="arrow" />
              )}
            </ListItemButton>
          </ListItem>
          <Collapse
            in={activeMenu === "Manage Properties"}
            timeout="auto"
            unmountOnExit
            id="submenu"
          >
            <List component="div" disablePadding>
              <ListItemButton
                className={
                  activesubMenu === "Add New Property"
                    ? "activeSubmenuItem"
                    : "inactiveSubmenuItem"
                }
                onClick={() => handleSubmenuClick("Add New Property")}
              >
                <ListItemIcon>
                  <AddIcon className="addicon" />
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="Add New Property"
                  className="color-text"
                />
              </ListItemButton>
              <ListItemButton
                className={
                  activesubMenu === "Manage Areas/Slots"
                    ? "activeSubmenuItem"
                    : "inactiveSubmenuItem"
                }
                onClick={() => handleSubmenuClick("Manage Areas/Slots")}
              >
                <ListItemIcon>
                  <img className="cou-img" src={Areaset} alt="Areaset" />
                </ListItemIcon>
                <ListItemText
                  inset
                  className="color-text"
                  primary="Manage Areas/Slots"
                />
              </ListItemButton>
            </List>
          </Collapse>
        </React.Fragment>
      </List>

      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Reservations")}
            className={
              activeMenu === "Reservations" ? "activeMenu" : "inheritmenu"
            }
          >
            <ListItemIcon>
              <img className="cou-img" src={Reservation} alt="Reservation" />
            </ListItemIcon>
            <ListItemText
              primary="Reservations"
              className={
                activeMenu === "Reservations" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Manage Coupons")}
            className={
              activeMenu === "Manage Coupons" ? "activeMenu" : "inheritmenu"
            }
          >
            <ListItemIcon>
              <img className="cou-img" src={Coupon} alt="Coupon" />
            </ListItemIcon>
            <ListItemText
              primary="Manage Coupons"
              className={
                activeMenu === "Manage Coupons" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />

      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Hunters")}
            className={activeMenu === "Hunters" ? "activeMenu" : "inheritmenu"}
          >
            <ListItemIcon>
              <img className="cou-img" src={Huntersicon} alt="Huntersicon" />
            </ListItemIcon>
            <ListItemText
              primary="Hunters"
              className={
                activeMenu === "Hunters" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Hunters Review")}
            className={
              activeMenu === "Hunters Review" ? "activeMenu" : "inheritmenu"
            }
          >
            <ListItemIcon>
              <img className="cou-img" src={Rating} alt="Rating" />
            </ListItemIcon>
            <ListItemText
              primary="Hunters Review"
              className={
                activeMenu === "Hunters Review" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Real Time Tracking")}
            className={
              activeMenu === "Real Time Tracking" ? "activeMenu" : "inheritmenu"
            }
          >
            <ListItemIcon>
              <img className="cou-img" src={Layer} alt="Layer" />
            </ListItemIcon>
            <ListItemText
              primary="Real Time Tracking"
              className={
                activeMenu === "Real Time Tracking"
                  ? "activeMenu"
                  : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>

      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Earnings")}
            className={activeMenu === "Earnings" ? "activeMenu" : "inheritmenu"}
          >
            <ListItemIcon>
              <div className={activeMenu == "Earnings"? "money_icon_active" : "money-icon"}>
                <FaMoneyBillWave />
              </div>
            </ListItemIcon>
            <ListItemText
              primary="Earnings"
              className={
                activeMenu === "Earnings" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>

      <Divider />

      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleClick("Help")}
            className={
              activeMenu === "Help" ? "activeMenu" : "inheritmenu"
            }
          >
            <ListItemIcon>
              <HelpIcon sx={{ color: activeMenu === "Help" ? "#fff" : "rgb(218, 150, 90)" }} />
            </ListItemIcon>
            <ListItemText
              primary="Help"
              className={
                activeMenu === "Help" ? "activeMenu" : "inheritmenu"
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  // Remove this const when copying and pasting into your project.
  const container =
    window !== undefined ? () => window().document.body : undefined;



  return (
    <>

      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <AppBar
          className="app-bar-landowner"
          position="fixed"
          sx={{
            width: "100%",
            ml: 0,
            "@media (min-width:1024px)": {
              width: `calc(100% - ${drawerWidth}px)`,
              ml: `${drawerWidth}px`,
            },
          }}
        >
          <Toolbar>


            <div className="main_container">
              <div className="header_left_content">
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{
                    mr: 2,
                    display: "block",
                    "@media (min-width:1024px)": {
                      display: "none", // hide at 1024px and above
                    },
                  }}
                >
                  <MenuIcon />
                </IconButton>
                {currentpage == "/managearea" ? (
                  <div className="header-btndiv">
                    <h1>Manage Properties</h1>
                  </div>
                ) : null}
                {currentpage == "/managecoupons" ? (
                  <div className="header-btndiv">
                    <h1>Manage Coupons</h1>
                  </div>
                ) : null}

                {currentpage.startsWith("/reservationdetails") ? (
                  <div className="header-btndiv">
                    <div className="header-btnicon" onClick={handleReservationBack}>
                      <ArrowBackIcon />
                    </div>
                    <h1>Reservation Details</h1>
                  </div>
                ) : null}

                {currentpage == "/realtracking" ? (
                  <div className="header-btndiv">
                    <h1>Real Time Tracking</h1>
                  </div>
                ) : null}

                {currentpage == "/earnings" ? (
                  <div className="header-btndiv">
                    <h1>Earnings</h1>
                  </div>
                ) : null}

                {currentpage == "/hunters" ? (
                  <div className="header-btndiv">
                    <h1>Hunters </h1>
                  </div>
                ) : null}

                {currentpage == "/huntersreview" ? (
                  <div className="header-btndiv">
                    <h1>Hunters Review</h1>
                  </div>
                ) : null}

                {currentpage == "/reservations" ? (
                  <div className="header-btndiv">
                    <h1>Reservations</h1>
                  </div>
                ) : null}

                {currentpage == "/slotproperty" ? (
                  <div className="header-btndiv">
                    <h1>Slots on Property</h1>
                  </div>
                ) : null}

                {currentpage == "/chats" ? (
                  <div className="header-btndiv">
                    <h1>Chats</h1>
                  </div>
                ) : null}

                {currentpage == "/propertydetailsmap" ||
                  currentpage == "/huntersdetails" ? (
                  <div className="header-btnicon" onClick={handlePropertyback}>
                    <ArrowBackIcon />
                  </div>
                ) : null}

                {currentpage == "/createcoupon" ? (
                  <div className="header-btnicon" onClick={handleCreatecouponback}>
                    <ArrowBackIcon />
                  </div>
                ) : null}

                {currentpage == "/propertydetails" ? (
                  <div className="header-icondiv">
                    <div className="header-btnicon" onClick={handlePropertyback}>
                      <ArrowBackIcon />
                    </div>
                    <h1>Property Details</h1>
                  </div>
                ) : null}


                {currentpage == "/help" ? (
                  <div className="header-icondiv">
                    <h1>Help</h1>
                  </div>
                ) : null}

                {currentpage == "/upcomingreservations" ? (
                  <div className="header-icondiv">
                    <div className="header-btnicon" onClick={handleHunterBack}>
                      <ArrowBackIcon />
                    </div>
                    <h1>{reservationName}</h1>
                  </div>
                ) : null}

                {currentpage == "/reservetonsidhistoryid" ? (
                  <div className="header-icondiv">
                    <div className="header-btnicon" onClick={handlePropertyback}>
                      <ArrowBackIcon />
                    </div>
                    <h1>{reservationName}</h1>
                  </div>
                ) : null}

                {currentpage == "/realtrackingdetails" ? (
                  <div className="header-icondiv">
                    <div className="header-btnicon" onClick={handleRealtrackback}>
                      <ArrowBackIcon />
                    </div>
                    <h1>Real Time Tracking</h1>
                  </div>
                ) : null}

                <div className="current-season">
                  <select
                    id="seasonSelect"
                    className="form-select"
                    value={selectedSeason || ""}
                    onChange={handleSeasonChange}
                  >
                    <option value="" disabled>
                      Select Season
                    </option>

                    {seasons?.map((ele, index) => (
                      <option key={ele._id || index} value={ele._id}>
                        {ele.seasonName}
                      </option>
                    ))}
                  </select>
                  {isCurrentSeason && <div className="season-drop-down-badge">
                    <span>
                      Current Season
                    </span>
                  </div>}
                </div>
              </div>

              <div className="nev_right_content">
                {/* Notification Bell */}
                <div className="dropdown">
                  <div
                    className="belldiv btn-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={closeallnotification}
                  >
                    <img src={Bellicon} alt="Bellicon" />
                    {readnotifications.length > 0 ? (
                      <p className="bell_notification">{readnotifications.length}</p>
                    ) : null}
                  </div>

                  <ul className="dropdown-menu bell_drop">
                    <h4 className="notification-title">Notifications</h4>
                    {notifications.length ? (
                      notifications.map((label, index) => (
                        <li key={index}>
                          <div
                            className="dropdown-item"
                            onClick={() =>
                              label.type === "property"
                                ? opennotification("/propertyreview?index=" + label.selectedid)
                                : opennotificationreservation(label)
                            }
                          >
                            {label.msg}
                          </div>
                        </li>
                      ))
                    ) : (
                      <p className="px-3">No data!</p>
                    )}
                  </ul>
                </div>

                {/* Profile Dropdown */}
                <div className="dropdown">
                  <div
                    className="btn-secondary dropdown-toggle top-main"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={handleDrop}
                  >
                    <div className="inner_box">
                      <div className="top-image">
                        <img
                          className="Profileimg"
                          src={
                            userdata.image
                              ? process.env.REACT_APP_BASEURL + "/" + userdata.image
                              : Profileimg
                          }
                          alt="Profile"
                        />
                      </div>

                      {!isMobile ? (
                        <>
                          <div className="top-midtext">
                            <p>{userdata.email} </p>
                            <p>{userdata.firstname} {userdata.lastname}</p>
                          </div>
                          <div className="top-icon">
                            <KeyboardArrowDownIcon />
                          </div>
                        </>
                      ) : null}


                      <ul className="dropdown-menu">
                        {isMobile ? (
                          <li>
                            <div className="user-drop">
                              {/* <div className="">
                                <img
                                  className="Profileimg"
                                  src={
                                    userdata.image
                                      ? process.env.REACT_APP_BASEURL + "/" + userdata.image
                                      : Profileimg
                                  }
                                  alt="Profile"
                                />
                              </div> */}
                              <div className="top-midtext">
                                <p>{userdata.email} </p>
                                <p>{userdata.firstname} {userdata.lastname}</p>
                              </div>
                            </div>
                          </li>
                        ) : null}
                        <li>
                          <Link className="dropdown-item" onClick={goToProfile}>
                            My Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={handleChagepassword}
                          >
                            Change Password
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" onClick={handleLogoutsubmit}>
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>


                </div>
              </div>

            </div>

          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: "auto",
            flexShrink: 1,
            "@media (min-width:1024px)": {
              width: drawerWidth,
              flexShrink: 0,
            },
          }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: {
                xs: "block", "@media (min-width:1024px)": {
                  display: "none" // hide drawer from 1024px and above
                },
              },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth
              }
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: {
                xs: "none", "@media (min-width:1024px)": {
                  display: "block" // hide drawer from 1024px and above
                },
              },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth
              }
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          {...(location.pathname !== "/profile" && { component: "main" })}
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />

          {props.children}
        </Box>
      </Box>

      {popstatus && (
        <div className="chagepassword-popup">
          <div className="chagepassword-content">
            <i
              className="fa-solid fa-xmark"
              onClick={handleChagepasswordclose}
            ></i>

            <div className="chagepass-popupcontent">
              <h1>Change Password</h1>
              <p>To change your password, please fill the fields below.</p>

              <div className="form-row">
                <div className="input-group">
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="Current Password"
                    name="currentpassword"
                    onChange={inputsHandler}
                    value={stepinputField.currentpassword}
                    ref={currentPasswordRef}
                  />
                  <button
                    type="button"
                    className="eye-icon btn btn-outline-secondary"
                    onClick={currenthandleType}
                  >
                    {currentpasswordicon ? (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </button>
                </div>
                <div className="input-group">
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="New Password"
                    name="newpassword"
                    onChange={inputsHandler}
                    value={stepinputField.newpassword}
                    ref={newPasswordRef}
                  />
                  <button
                    type="button"
                    className="eye-icon btn btn-outline-secondary"
                    onClick={handleType}
                  >
                    {passwordicon ? (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </button>
                </div>
                <div className="input-group">
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="Confirm New Password"
                    name="confirmpassword"
                    onChange={inputsHandler}
                    value={stepinputField.confirmpassword}
                    ref={confirmPasswordRef}
                  />
                  <button
                    type="button"
                    className="eye-icon btn btn-outline-secondary"
                    onClick={chandleType}
                  >
                    {cpasswordicon ? (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </button>
                </div>
              </div>
              <div className="form-row w-100">
                <button
                  type="submit"
                  className="users_btn change-passbtn"
                  onClick={handleChagepasswordsubmit}
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {successPopup && (
        <div className="chagesuccess-popup">
          <div className="chagesuccess-content">
            <i className="fa-solid fa-xmark" onClick={handlesuccessPopup}></i>
            <div className="chagesuccess-contentdiv">
              <img src={Successicon} alt="Successicon" />
              <h1>Password Changed</h1>
              <h1> Successfully </h1>
            </div>
          </div>
        </div>
      )}

      {logoutpopstatus && (
        <div className="logout-popup">
          <div className="logout-content">
            <i className="fa-solid fa-xmark" onClick={handlepopupclose}></i>
            <div className="logout-contentdiv">
              <img src={Logouticon} alt="Logouticon" />
              <h1>Are you Sure?</h1>
              <p>Are you absolutely sure you want to Logout?</p>
            </div>
            <div className="logout-btn">
              <button className="btn1" onClick={handlepopupclose}>
                Cancel
              </button>
              <button className="btn2" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Sidebar.propTypes = {
  window: PropTypes.func,
  children: PropTypes.node,
};

export default Sidebar;